/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { get as _get, cloneDeep as _cloneDeep } from 'lodash';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { DataGridPro, useGridApiRef as useApiRef } from '@mui/x-data-grid-pro';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Auth, { ProfileContext } from '../../../../data/auth-service';
import GCPService from '../../../../data/gcp-service';
import PacketMirrorService, { PacketMirrorFields } from '../../../../data/packetmirror-service';
import InstanceGroupService, { InstanceGroupFields } from '../../../../data/instancegroup-service';
import LoadBalancerService, { LoadBalancerFields } from '../../../../data/loadbalancer-service';
import SystemService from '../../../../data/system-service';
import DataContext from '../../../../data/data-context';
import ConfirmationDialog from '../../../../components/confirmationdlg';
import SearchBar from '../../../../components/searchbar';
import {
    LoadingOverlay,
} from '../../../../components/xgrid/overlays';
import useWindowSize from '../../../../libraries/usewindowsize';
import { Typography, Popper, Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import NoresultsOverlay from '../../../../components/noresultsOverlay';

const useStyles = makeStyles((theme) => ({
    buttonRight: {
        float: 'right',
        marginLeft: theme.spacing(2),
    },
    roleUsers: {
        display: 'inline',
    },
    fullWidth: {
        width: '100%',
    },
    tabBar: {
        marginTop: theme.spacing(3),
    },
    popper: {
        direction: 'ltr',
        textAlign: 'left',
        width: '20%',
        paddingTop: 5
    },
    boxContainer: {
        fontFamily: '"Noto Sans", "Helvetica", "Arial", sans-serif',
        padding: theme.spacing(1.5),
        fontSize: 12,
        fontWeight: 'normal',
        letterSpacing: '0.5px',
    }
}));

const GCP = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();
    const [gcpTab, setGCPTab] = useState(0);
    const [project, setProject] = useState();
    const [deleteInstanceGroupDialog, setDeleteInstanceGroupDialog] = useState(false);
    const [deletePacketMirrorDialog, setDeletePacketMirrorDialog] = useState(false);
    const [deleteLoadBalancerDialog, setDeleteLoadBalancerDialog] = useState(false);
    const [selectedInstanceGroup, setSelectedInstanceGroup] = useState(null);
    const [selectedPacketMirror, setSelectedPacketMirror] = useState(null);
    const [selectedLoadBalancer, setSelectedLoadBalancer] = useState(null);
    const { updateProfile, getProfile } = useContext(ProfileContext);
    const gcpPerms = Auth.permissions.get('GCP');
    const [readonly] = useState(!gcpPerms.write);
    const [upload, setUpload] = useState(false);
    const instanceAPIRef = useApiRef();
    const packetMirrorAPIRef = useApiRef();
    const loadBalancerAPIRef = useApiRef();
    const { height } = useWindowSize();
    const { systemSettings, updateSystemSettings } = useContext(DataContext);
    const [loading, setLoading] = useState(true);
    const [enabled, setEnabled] = useState(false);
    const [instanceGroupColumnWidth, setInstanceGroupColumnWidth] = useState({});
    const [packetMirrorColumnWidth, setPacketMirrorColumnWidth] = useState({});
    const [loadBalancerColumnWidth, setLoadBalancerColumnWidth] = useState({});
    const [valid, setValid] = useState(false);
    const [sensors, setSensors] = useState([]);
    const [applianceFilter] = useState({
        sensor: true,
        btsensor: false,
    });
    const [filter] = useState({
        q: '',
        limit: 1000,
        name: '',
        host: '',
        model: '',
        status: {
            critical: true,
            warning: true,
            normal: true,
        },
        policies: [],
        sort: 'status+desc',
    });

    const [instanceGroupData, setInstanceGroupData] = useState([]);
    const [packetMirrorData, setPacketMirrorData] = useState([]);
    const [loadBalancerData, setLoadBalancerData] = useState([]);
    const [forwardingRules, setForwardingRules] = useState([]);
    const [gcp, setGCP] = useState({})
    const [anchorEl, setAnchorEl] = useState(null);
    const tab0Ref = useRef(null);
    const tab1Ref = useRef(null);
    const tab2Ref = useRef(null);

    const handleClosePopup = (e, tab) => {
        setAnchorEl(null);
        let tabName = '';
        switch (tab) {
            case 0:
                tabName = 'hide_group';
                break;
            case 1:
                tabName = 'hide_loadbalancer';
                break;
            case 2:
                tabName = 'hide_packetmirroring';
                break;
        }
        updateProfile('gcp', { ...getProfile('gcp'), [tabName]: true });
    }

    const shouldShowPopper = () => {
        const p = getProfile('gcp');
        if (gcpTab === 0) return !p.hide_group;
        if (gcpTab === 1) return !p.hide_loadbalancer;
        if (gcpTab === 2) return !p.hide_packetmirroring;

        return false;
    };

    const openPopper = Boolean(anchorEl) && shouldShowPopper();


    const fetchData = async () => {
        try {
            let instanceGroups = await InstanceGroupService.getInstanceGroups();
            let groupItems = [];
            for (var [zone, info] of Object.entries(instanceGroups.items)) {
                if (info.instanceGroups) {
                    info.instanceGroups.map((instanceGroup) => groupItems.push(instanceGroup));
                }
            }
            setInstanceGroupData(groupItems);
            setLoading(false)
        } catch (error) {
            console.log(`Error while fetching instances: ${error.message}`);
        }
    }

    const fetchPacketMirror = async () => {
        try {
            await PacketMirrorService.AggregatedListpacketMirrors().then((res) => {
                const data = Object.keys(res.items)
                    .filter((key) => res.items[key].packetMirrorings)
                    .flatMap((key) =>
                        res.items[key].packetMirrorings.map((group) => ({
                            ...group,
                            zone: group.zone || key
                        }))
                    );
                setPacketMirrorData(data);
            });
            setLoading(false)

        } catch (error) {
            console.log(`Error while fetching Aggregated Packet mirrors: ${error.message}`);
        }
    }


    const fetchLB = async () => {
        try {
            let backendService = await LoadBalancerService.getLoadBalancers();
            let bsItems = [];
            for (var [zone, info] of Object.entries(backendService.items)) {
                let backendservices = info.backendServices;
                if (backendservices) {
                    backendservices.filter((service) => {
                        if (service.loadBalancingScheme === 'INTERNAL') {
                            bsItems.push(service);
                        }
                    });
                }
            }
            setLoadBalancerData(bsItems);
            setLoading(false);
        } catch (error) {
            console.log(`Error while fetching Load balancers: ${error.message}`);
        }
    }

    useEffect(() => {
        if (tab0Ref.current) {
            setAnchorEl(tab0Ref.current);
        }
    }, []);

    useEffect(() => {
        if (systemSettings.gcp && systemSettings.proxy) {
            const a = _cloneDeep(systemSettings.gcp);
            //updateSystemSettings({gcp:{hide_group:false, hide_loadbalancer: false, hide_packetmirroring: false}});
            setUpload(true)
            setGCP(a)
            setGCPTab(0);
        } else {
            setUpload(false)
            setLoading(false)
        }
    }, [systemSettings, systemSettings.gcp]);

    useEffect(() => {
        if (upload) {
            setLoading(true)
            fetchData();
            fetchPacketMirror();
            fetchLB();
        }
    }, [upload])


    useEffect(() => {

        const fetchHost = async () => {
            try {
                const host = await GCPService.getXPNhosts();
                if (host.name) {
                    setProject(host.name)
                }
                else {
                    throw new Error(host)
                }
            }
            catch (error) {
                console.log(`Error while fetching XPN hosts :${error.message}`)
            }
        }

        fetchHost();
        getConfig()
    }, [])


    useEffect(() => {

        if (location.state && location.state.tab) {
            setGCPTab(location.state.tab);
        }
        if (location.state && location.state.upload) {
            setUpload(location.state.upload);
        }

        setInstanceGroupColumnWidth(getProfile('instanceGroupData').instanceGroupColumnWidth || {});
        setPacketMirrorColumnWidth(getProfile('packetMirrorData').packetMirrorColumnWidth || {});
        setLoadBalancerColumnWidth(getProfile('loadBalancerData').loadBalancerColumnWidth || {});
    }, [location.state]);



    const handleInstanceGroupColumnResize = (params) => {
        const widths = instanceAPIRef.current.getAllColumns().reduce((a, c) => {
            a[c.headerName] = c.width;
            return a;
        }, {});
        setInstanceGroupColumnWidth(widths);
    };

    const handlePacketMirrorColumnResize = (params) => {
        const widths = packetMirrorAPIRef.current.getAllColumns().reduce((a, c) => {
            a[c.headerName] = c.width;
            return a;
        }, {});
        setPacketMirrorColumnWidth(widths);
    };

    const handleLoadBalancerColumnResize = (params) => {
        const widths = loadBalancerAPIRef.current.getAllColumns().reduce((a, c) => {
            a[c.headerName] = c.width;
            return a;
        }, {});
        setLoadBalancerColumnWidth(widths);
    };

    const getConfig = async () => {
        try {
            let res = await GCPService.getConfig();
            if (res) {
                setGCP(res)
                setUpload(true);
            }
        } catch (error) {
            console.error(`Error fetching configuration: ${error.message}`);
        }
    };



    const handleInstanceGroupColumnReorder = () => {
        let order = [];
        setTimeout(() => {
            order = instanceAPIRef.current.getAllColumns().reduce((a, c) => {
                a.push(c.headerName);
                return a;
            }, []);
        });
    };

    const handlePacketMirrorColumnReorder = () => {
        let order = [];
        setTimeout(() => {
            order = packetMirrorAPIRef.current.getAllColumns().reduce((a, c) => {
                a.push(c.headerName);
                return a;
            }, []);
        });
    };

    const handleLoadBalancerColumnReorder = () => {
        let order = [];
        setTimeout(() => {
            order = loadBalancerAPIRef.current.getAllColumns().reduce((a, c) => {
                a.push(c.headerName);
                return a;
            }, []);
        });
    };

    const instanceGrouptableRenderers = {
        name: ({ row }) => <div>{row.name}</div>,
        instances: ({ row }) => <div>{row.size || 0}</div>,
        creationTimestamp: ({ row }) => <div>{row.creationTimestamp}</div>,
        zone: ({ row }) => {
            const zoneURL = row.zone;
            const zone = zoneURL.split('/').pop();
            return <div>{zone}</div>;
        }
    };

    const packetMirrortableRenderers = {
        name: ({ row }) => <div>{row.name}</div>,
        enable: ({ row }) => <div>{row.enable === "TRUE" ? 'Enabled' : 'Disabled'}</div>,
        region: ({ row }) => {
            const regionURL = row.region;
            const region = regionURL.split('/').pop();
            return <div>{region}</div>;
        },
        priority: ({ row }) => <div>{row.priority}</div>,
        network: ({ row }) => {
            const networkURL = row.network.url;
            const network = networkURL.split('/').pop();
            return <div>{network}</div>;
        },
        instances: ({ row }) => {
            const instanceURLs = Array.isArray(row?.mirroredResources?.instances)
                ? row.mirroredResources.instances
                : [];
            const subnetworkURLs = Array.isArray(row?.mirroredResources?.subnetworks)
                ? row.mirroredResources.subnetworks
                : [];

            const extractNames = (urls) => urls
                .filter(item => typeof item.url === 'string')
                .map(item => {
                    try {
                        return item.url.split('/').pop();
                    } catch (error) {
                        console.error('Error processing URL:', error);
                        return '';
                    }
                })
                .filter(name => name);
            const allContents = [
                ...extractNames(instanceURLs),
                ...extractNames(subnetworkURLs)
            ];
            return (
                <div>
                    {allContents.length > 0 ? allContents.join(', ') : ''}
                </div>
            );
        },
        collectorIlb: ({ row }) => {
            const collectorIlbURL = row.collectorIlb.url;
            const collector = collectorIlbURL.split('/').pop();
            return <div>{collector}</div>;
        },
        filter: ({ row }) => {
            const filter = row.filter.cidrRanges;
            return (
                <div>
                    {filter && filter.length > 0 ? 'Filtered Traffic' : 'All IPv4 traffic'}
                </div>
            );
        }
    };

    const loadBalancertableRenderers = {
        name: ({ row }) => <div>{row.name}</div>,
        loadBalancingScheme: ({ row }) => <div> {row.loadBalancingScheme}</div>,
        region: ({ row }) => {
            const regionURL = row.region;
            const region = regionURL.split('/').pop();
            return <div>{region}</div>;
        },
        network: ({ row }) => {
            const networkURL = row.network;
            const network = networkURL.split('/').pop();
            return <div>{network}</div>;
        },
        protocol: ({ row }) => <div> {row.protocol}</div>,
        healthChecks: ({ row }) => {
            const healthURL = row.healthChecks[0];
            const health = healthURL.split('/').pop();
            return <div>{health}</div>;
        },
        backends: ({ row }) => {
            const backends = row.backends.length;
            return <div>{backends}</div>
        }
    };


    const instanceGroupColumns = InstanceGroupFields.map((f) => {
        return {
            ...f,
            sortable: true,
            width: instanceGroupColumnWidth[f.title] || 0,
            ...(!instanceGroupColumnWidth[f.title] ? { flex: 1 } : {}),
            headerName: f.title,
            valueGetter: (p) => {
                return p.row[f.variable];
            },
            type: 'string',
            disableColumnMenu: true,
            hidden: false,
            renderCell: instanceGrouptableRenderers[f.variable],
        };
    });

    const packetMirrorColumns = PacketMirrorFields.map((f) => {
        return {
            ...f,
            sortable: true,
            width: packetMirrorColumnWidth[f.title] || 0,
            ...(!packetMirrorColumnWidth[f.title] ? { flex: 1 } : {}),
            headerName: f.title,
            valueGetter: (p) => {
                return p.row[f.variable];
            },
            type: 'string',
            disableColumnMenu: true,
            hidden: false,
            renderCell: packetMirrortableRenderers[f.variable],
        };
    });

    const loadBalancerColumns = LoadBalancerFields.map((f) => {
        return {
            ...f,
            sortable: true,
            width: loadBalancerColumnWidth[f.title] || 0,
            ...(!loadBalancerColumnWidth[f.title] ? { flex: 1 } : {}),
            headerName: f.title,
            valueGetter: (p) => {
                return p.row[f.variable];
            },
            type: 'string',
            disableColumnMenu: true,
            hidden: false,
            renderCell: loadBalancertableRenderers[f.variable],
        };
    });

    const handleSelectInstanceGroup = (s) => {
        setSelectedInstanceGroup(s.row);
    };

    const handleSelectPacketMirror = (s) => {
        setSelectedPacketMirror(s.row);
    };

    const handleSelectLoadBalancer = async (s) => {
        try {
            let res = await LoadBalancerService.getFrontendServicesList(GCPService.selfLinktoName(s.row.region));
            if (res.items) {
                const rules = res.items.filter((rule) => rule.backendService === s.row.selfLink);
                setForwardingRules(rules);
                setSelectedLoadBalancer(s.row);
            } else {
                setForwardingRules([]);
            }
        } catch (error) {
            throw new Error(error)
        }
    };

    const handleCreateInstanceGroup = () => {
        navigate('/system/port_mirroring/gcp/create_instance_group');
    };

    const handleCreatePacketMirror = () => {
        navigate(`/system/port_mirroring/gcp/create_packet_mirror`, { state: { hostproject: project } });
    };

    const handleCreateLoadBalancer = () => {
        navigate('/system/port_mirroring/gcp/create_load_balancer');
    };


    const handleEditInstanceGroup = () => {
        navigate(
            `/system/port_mirroring/gcp/update_instance_group/${selectedInstanceGroup.id}`, { state: { data: selectedInstanceGroup } }
        );
    };

    const handleEditPacketMirror = () => {
        navigate(
            `/system/port_mirroring/gcp/update_packet_mirror/${selectedPacketMirror.id}`, { state: { data: selectedPacketMirror, hostproject: project } }
        );
    };

    const handleEditLoadBalancer = () => {
        navigate(
            `/system/port_mirroring/gcp/update_load_balancer/${selectedLoadBalancer.id}`, { state: { data: selectedLoadBalancer } }
        );
    };


    const handleGCPConfig = async (e) => {
        navigate('/system/port_mirroring/gcp/gcp_credentials', { state: { creds: gcp } });
    };



    const handleOpenDeleteInstanceGroup = () => {
        setDeleteInstanceGroupDialog(true);
    };

    const handleOpenDeletePacketMirror = () => {
        setDeletePacketMirrorDialog(true);
    };

    const handleOpenDeleteLoadBalancer = () => {
        setDeleteLoadBalancerDialog(true);
    };

    const handleCloseDeleteInstanceGroupDialog = () => {
        setDeleteInstanceGroupDialog(false);
        setSelectedInstanceGroup(null);
    };

    const handleCloseDeletePacketMirrorDialog = () => {
        setDeletePacketMirrorDialog(false);
        setSelectedPacketMirror(null);
    };

    const handleCloseDeleteLoadBalancerDialog = () => {
        setDeleteLoadBalancerDialog(false);
        setSelectedLoadBalancer(null);
    };

    const handleDeleteInstanceGroup = async () => {
        try {
            const zone = GCPService.selfLinktoName(selectedInstanceGroup.zone);
            await InstanceGroupService.deleteInstanceGroup(zone, selectedInstanceGroup.name);
            const updatedInstanceGroups = [...instanceGroupData];
            const index = updatedInstanceGroups.findIndex(
                (item) => item.id === selectedInstanceGroup.id
            );
            updatedInstanceGroups.splice(index, 1);
            setInstanceGroupData(updatedInstanceGroups);
            setDeleteInstanceGroupDialog(false);
            toast.success('Instance Group deleted successfully');
        } catch (error) {
            toast.error(`Failed to delete Instance Group ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleDeletePacketMirror = async () => {
        try {
            const region = GCPService.selfLinktoName(selectedPacketMirror.region, "region");
            await PacketMirrorService.DeletepacketMirror(region, selectedPacketMirror.name);
            const updatedPacketMirrors = [...packetMirrorData]
            const index = updatedPacketMirrors.findIndex(
                (item) =>
                    item.id === selectedPacketMirror.id
            );

            updatedPacketMirrors.splice(index, 1);
            setPacketMirrorData(updatedPacketMirrors);
            setDeletePacketMirrorDialog(false);
            toast.success('Packet Mirror deleted successfully');
        } catch (error) {
            toast.error(`Failed to delete Packet Mirror: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteLoadBalancer = async () => {
        try {
            for (var i = 0; i < forwardingRules.length; i++) {
                await LoadBalancerService.deleteForwardingRule(GCPService.selfLinktoName(selectedLoadBalancer.region), GCPService.selfLinktoName(forwardingRules[i].name));
            }

            setTimeout(() => {
                LoadBalancerService.deleteBackendService(GCPService.selfLinktoName(selectedLoadBalancer.region), selectedLoadBalancer.name);
            }, 10000);

            const updatedLoadBalancers = [...loadBalancerData];
            const index = updatedLoadBalancers.findIndex(
                (item) =>
                    item.id === selectedLoadBalancer.id
            );

            updatedLoadBalancers.splice(index, 1);
            setLoadBalancerData(updatedLoadBalancers);
            setDeleteLoadBalancerDialog(false);
            toast.success('Load balancer deleted successfully');
        } catch (error) {
            toast.error(`Failed to delete Load balancer: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleTabChange = (e, tab) => {
        setGCPTab(tab);
        switch (tab) {
            case 0:
                setAnchorEl(tab0Ref.current);
                break;
            case 1:
                setAnchorEl(tab1Ref.current);
                break;
            case 2:
                setAnchorEl(tab2Ref.current);
                break;
        }
    };

    const handleInstanceGroupsFilter = ({ search }) => {
        instanceAPIRef.current.setFilterModel({
            items: [
                { operatorValue: 'contains', columnField: 'name', value: search },
            ],
        });
    };

    const handlePacketMirrorsFilter = ({ search }) => {
        packetMirrorAPIRef.current.setFilterModel({
            items: [
                { operatorValue: 'contains', columnField: 'name', value: search },
            ],
        });
    };


    const handleLoadBalancerFilter = ({ search }) => {
        loadBalancerAPIRef.current.setFilterModel({
            items: [
                { operatorValue: 'contains', columnField: 'name', value: search },
            ],
        });
    };

    const descTabs = [
        "An instance group is a collection of virtual machine (VM) instances managed as a single entity. In the context of NDR, this includes a fleet of VMs running virtual sensors, allowing for effective management and load balancing across the group.",
        "Internal passthrough Network Load Balancers distribute traffic among internal VM instances within the same region of a Virtual Private Cloud (VPC) network.",
        "Packet Mirroring policies contain all the necessary information for configuring packet mirroring in GCP."
    ];

    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid item mt={1} xs={12}>
                    <Box>
                        {(gcpPerms.write || gcpPerms.admin) && (
                            <Button
                                variant="contained"
                                className={classes.buttonRight}
                                color="secondary"
                                aria-label="configure"
                                onClick={handleGCPConfig}
                            >
                                <EditIcon /> Configure Account Key
                            </Button>
                        )}
                    </Box>
                    <Box className={classes.fullWidth} hidden={gcpTab !== 0}>
                        <Box display="flex" justifyContent="space-between">
                            <Box>
                                <SearchBar immediate onSearch={handleInstanceGroupsFilter} searchservice={InstanceGroupService} />
                            </Box>
                            <Box mr={2}>
                                {!readonly && (
                                    <Button
                                        variant="contained"
                                        className={classes.buttonLeft}
                                        color="primary"
                                        disabled={!upload}
                                        aria-label="add Instance Group"
                                        onClick={handleCreateInstanceGroup}
                                    >
                                        <AddIcon /> Create Instance Groups
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Box>
                    <Box className={classes.fullWidth} hidden={gcpTab !== 1}>
                        <Box display="flex" justifyContent="space-between">
                            <SearchBar immediate onSearch={handleLoadBalancerFilter} searchservice={LoadBalancerService} />
                            <Box mr={2}>
                                {!readonly && (
                                    <Button
                                        variant="contained"
                                        className={classes.buttonLeft}
                                        color="primary"
                                        aria-label="add LoadBalancer"
                                        onClick={handleCreateLoadBalancer}
                                        disabled={!upload}
                                    >
                                        <AddIcon /> Create Load Balancer
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Box>
                    <Box className={classes.fullWidth} hidden={gcpTab !== 2}>
                        <Box display="flex" justifyContent="space-between">
                            <SearchBar immediate onSearch={handlePacketMirrorsFilter} searchservice={PacketMirrorService} />
                            <Box mr={2}>
                                {!readonly && (
                                    <Button
                                        variant="contained"
                                        className={classes.buttonLeft}
                                        color="primary"
                                        aria-label="add packet mirror"
                                        disabled={!upload}
                                        onClick={handleCreatePacketMirror}
                                    >
                                        <AddIcon /> Create Packet Mirror
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Box>
                    <AppBar position="static" className={classes.tabBar}>

                        <Tabs value={gcpTab} onChange={handleTabChange}>
                            <Tab
                                ref={tab0Ref}
                                aria-label="Instance Groups"
                                label="Instance Groups"
                                value={0} />
                            <Tab
                                ref={tab1Ref}
                                aria-label="Load Balancers"
                                label="Load Balancers"
                                value={1}
                            />
                            <Tab
                                ref={tab2Ref}
                                aria-label="Packet Mirrors"
                                label="Packet Mirrors"
                                value={2}
                            />
                        </Tabs>

                        <Popper
                            open={openPopper}
                            anchorEl={anchorEl}
                            placement={'bottom-start'}
                            className={classes.popper}
                        >
                            <Paper elevation={2}>
                                <Box className={classes.boxContainer}>
                                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                        <Typography variant="h6" style={{ fontSize: 14, fontWeight: 'bold' }}>Learn about this</Typography>
                                        <Box>
                                            <IconButton
                                                name="close popup"
                                                aria-label="close"
                                                title="close"
                                                onClick={(e) => handleClosePopup(e, gcpTab)}
                                                size="small"
                                            >
                                                <CloseIcon style={{ width: '16px', height: '16px' }} />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                    <Box pt={1}>
                                        {descTabs[gcpTab]}
                                    </Box>
                                </Box>
                            </Paper>
                        </Popper>

                    </AppBar>
                    {gcpTab === 0 && <Box
                        value={gcpTab}
                        index={0}
                        hidden={gcpTab !== 0}
                        height={height - 310}
                        width="100%"
                    >
                        <DataGridPro
                            apiRef={instanceAPIRef}
                            components={{
                                Header: () => {
                                    return (
                                        <Box
                                            p={1}
                                            display="flex"
                                            justifyContent="flex-end"
                                            borderBottom="1px solid #666666"
                                        >
                                            <IconButton
                                                disabled={!selectedInstanceGroup}
                                                variant="contained"
                                                color="primary"
                                                name="edit instance"
                                                aria-label="edit instance"
                                                title="edit instance"
                                                onClick={handleEditInstanceGroup}
                                                size="large"
                                            >
                                                {readonly ? <VisibilityIcon /> : <EditIcon />}
                                            </IconButton>
                                            {!readonly && (
                                                <IconButton
                                                    disabled={!selectedInstanceGroup || !gcpPerms.delete}
                                                    variant="contained"
                                                    color="secondary"
                                                    name="delete filter"
                                                    aria-label="delete filter"
                                                    title="delete filter"
                                                    onClick={handleOpenDeleteInstanceGroup}
                                                    size="large"
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            )}
                                        </Box>
                                    );
                                },
                                LoadingOverlay: LoadingOverlay,
                                NoRowsOverlay: () => <NoresultsOverlay message="Create an Instance Group or use the one from Google Cloud to configure your Network Load Balancer." />,
                            }}
                            loading={loading}
                            rows={instanceGroupData}
                            columns={(() => {
                                const p = getProfile('instanceGroupData');
                                let c = instanceGroupColumns;

                                if (p.instanceGroupColumns && p.instanceGroupColumns.length) {
                                    c = p.instanceGroupColumns.map((v) => {
                                        for (let i = c.length; i--;) {
                                            if (v === c[i].headerName) {
                                                return c[i];
                                            }
                                        }
                                        return v;
                                    });
                                }
                                return c;
                            })()}
                            onRowClick={handleSelectInstanceGroup}
                            disableMultipleSelection
                            disableColumnMenu
                            getRowId={(r) => r.id}
                            disableVirtualization
                            onColumnResize={handleInstanceGroupColumnResize}
                            onColumnOrderChange={handleInstanceGroupColumnReorder}
                        />
                    </Box>}
                    {gcpTab === 1 &&
                        <Box
                            value={gcpTab}
                            index={1}
                            hidden={gcpTab !== 1}
                            height={height - 310}
                            width="100%"
                        >
                            <DataGridPro
                                apiRef={loadBalancerAPIRef}
                                components={{
                                    Header: () => {
                                        return (
                                            <Box
                                                p={1}
                                                display="flex"
                                                justifyContent="flex-end"
                                                borderBottom="1px solid #666666"
                                            >
                                                <IconButton
                                                    disabled={!selectedLoadBalancer}
                                                    variant="contained"
                                                    color="primary"
                                                    name="edit load balancer"
                                                    aria-label="edit load balancer"
                                                    title="edit load balancer"
                                                    onClick={handleEditLoadBalancer}
                                                    size="large"
                                                >
                                                    {readonly ? <VisibilityIcon /> : <EditIcon />}
                                                </IconButton>
                                                {!readonly && (
                                                    <IconButton
                                                        disabled={!selectedLoadBalancer || !gcpPerms.delete}
                                                        variant="contained"
                                                        color="secondary"
                                                        name="delete load balancer"
                                                        aria-label="delete load balancer"
                                                        title="delete load balancer"
                                                        onClick={handleOpenDeleteLoadBalancer}
                                                        size="large"
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                )}
                                            </Box>
                                        );
                                    },
                                    LoadingOverlay: LoadingOverlay,
                                    NoRowsOverlay: () => <NoresultsOverlay message="Create an internal passthrough Network Load Balance to act as the packet mirroring collector." />,
                                }}
                                loading={loading}
                                rows={loadBalancerData}
                                columns={(() => {
                                    const p = getProfile('loadBalancerData');
                                    let c = loadBalancerColumns;
                                    if (p.loadBalancerColumns && p.loadBalancerColumns.length) {
                                        c = p.loadBalancerColumns.map((v) => {
                                            for (let i = c.length; i--;) {
                                                if (v === c[i].headerName) {
                                                    return c[i];
                                                }
                                            }
                                            return v;
                                        });
                                    }
                                    return c;
                                })()}
                                onRowClick={handleSelectLoadBalancer}
                                disableMultipleSelection
                                disableColumnMenu
                                disableVirtualization
                                getRowId={(r) => r.id}
                                onColumnResize={handleLoadBalancerColumnResize}
                                onColumnOrderChange={handleLoadBalancerColumnReorder}
                            />
                        </Box>}
                    {gcpTab === 2 && <Box
                        value={gcpTab}
                        index={2}
                        hidden={gcpTab !== 2}
                        height={height - 310}
                        width="100%"
                    >
                        <DataGridPro
                            apiRef={packetMirrorAPIRef}
                            components={{
                                Header: () => {
                                    return (
                                        <Box
                                            p={1}
                                            display="flex"
                                            justifyContent="flex-end"
                                            borderBottom="1px solid #666666"
                                        >
                                            <IconButton
                                                disabled={!selectedPacketMirror}
                                                variant="contained"
                                                color="primary"
                                                name="edit packet mirror"
                                                aria-label="edit packet mirror"
                                                title="edit packet mirror"
                                                onClick={handleEditPacketMirror}
                                                size="large"
                                            >
                                                {readonly ? <VisibilityIcon /> : <EditIcon />}
                                            </IconButton>
                                            {!readonly && (
                                                <IconButton
                                                    disabled={!selectedPacketMirror || !gcpPerms.delete}
                                                    variant="contained"
                                                    color="secondary"
                                                    name="delete packet mirror"
                                                    aria-label="delete packet mirror"
                                                    title="delete packet mirror"
                                                    onClick={handleOpenDeletePacketMirror}
                                                    size="large"
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            )}
                                        </Box>
                                    );
                                },
                                LoadingOverlay: LoadingOverlay,
                                NoRowsOverlay: () => <NoresultsOverlay message="Create a packet mirroring policy, by selecting the mirrored sources to forward network traffic to a load balancer." />,
                            }}
                            loading={loading}
                            rows={packetMirrorData}
                            columns={(() => {
                                const p = getProfile('packetMirrorData');
                                let c = packetMirrorColumns;

                                if (p.packetMirrorColumns && p.packetMirrorColumns.length) {
                                    c = p.packetMirrorColumns.map((v) => {
                                        for (let i = c.length; i--;) {
                                            if (v === c[i].headerName) {
                                                return c[i];
                                            }
                                        }
                                        return v;
                                    });
                                }
                                return c;
                            })()}
                            onRowClick={handleSelectPacketMirror}
                            disableMultipleSelection
                            disableColumnMenu
                            disableVirtualization
                            getRowId={(r) => r.id}
                            onColumnResize={handlePacketMirrorColumnResize}
                            onColumnOrderChange={handlePacketMirrorColumnReorder}
                        />
                    </Box>}
                </Grid>
            </Grid>
            <ConfirmationDialog
                onClose={handleCloseDeleteInstanceGroupDialog}
                onOK={handleDeleteInstanceGroup}
                open={deleteInstanceGroupDialog}
                message={`Are you sure you want to remove the Instance Group ${selectedInstanceGroup ? selectedInstanceGroup.name : ''}?`}
                warning={'This action cannot be undone'}
                title="Delete Instance Group"
                cancelLabel="Cancel"
                okLabel="Yes"
            />
            <ConfirmationDialog
                onClose={handleCloseDeletePacketMirrorDialog}
                onOK={handleDeletePacketMirror}
                open={deletePacketMirrorDialog}
                message={`Are you sure you want to remove the Packet Mirror ${selectedPacketMirror ? selectedPacketMirror.name : ''}?`}
                warning={'This action cannot be undone'}
                title="Delete Packet Mirror"
                cancelLabel="Cancel"
                okLabel="Yes"
            />
            <ConfirmationDialog
                onClose={handleCloseDeleteLoadBalancerDialog}
                onOK={handleDeleteLoadBalancer}
                open={deleteLoadBalancerDialog}
                message={`Are you sure you want to remove the Loadbalancer ${selectedLoadBalancer ? selectedLoadBalancer.name : ''}?`}
                warning={'This action cannot be undone'}
                title="Delete Loadbalancer"
                cancelLabel="Cancel"
                okLabel="Yes"
            />
        </React.Fragment>
    );
};

export default GCP;
